import { BaseTool } from '../BaseTool';

/**
 * Collaborate — starts worksharing: converts the local model into a
 * central model (network or cloud). Opens the Collaborate dialog.
 */
export class CollaborateSettingsTool extends BaseTool {
    id = 'COLLAB_SETTINGS';
    name = 'Collaborate';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('collaborate');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
